// src/components/Cases.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


function Cases() {
    const [cases, setCases] = useState([]);
    const navigate = useNavigate();
  
    useEffect(() => {
      const checkAuth = async () => {
        try {
          // Check if the user is authenticated
          const authResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth/status`, { withCredentials: true });
          if (!authResponse.data.isAuthenticated) {
            navigate('/login'); // Redirect to login if not authenticated
          } else {
            fetchCases(); // Fetch cases if authenticated
          }
        } catch (error) {
          console.error('Authentication check failed', error);
          navigate('/login'); // Redirect to login if the request fails
        }
      };
  
      const fetchCases = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/cases`, { withCredentials: true });
          setCases(response.data);
        } catch (error) {
          console.error('Failed to fetch cases', error);
          navigate('/continue-payment'); 
        }
      };
  
      checkAuth();
    }, [navigate]);
  
    return (
      <div className="min-h-screen p-8 bg-gray-50">
        <h1 className="text-3xl font-semibold text-gray-900 mb-6">Available Cases</h1>
        <ul className="space-y-4">
          {cases.map((c) => (
            <li key={c._id} className="p-4 border border-gray-200 rounded-lg bg-white shadow hover:shadow-lg transition">
              <h2 className="text-xl font-bold">{c.title}</h2>
              {/* Keep the following line out unless you make descriptions mandatory and in each case. Probably will delete this line */}
              {/* <p className="text-gray-600">{c.description.substring(0, 100)}...</p> */}
            </li>
          ))}
        </ul>
      </div>
    );
}


export default Cases;
